import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SYMBOL_CONTRACT_DATES } from "../utils/contractsData";
import "../styles/ContractsView.css";

const ContractsView = () => {
    const navigate = useNavigate();
    const [filterText, setFilterText] = useState("");
    const [activeContracts, setActiveContracts] = useState({});

    // Authentication check
    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            navigate("/");
            return;
        }
    }, [navigate]);

    // Find the active contract for each symbol based on current date
    useEffect(() => {
        const today = new Date();
        const active = {};

        Object.entries(SYMBOL_CONTRACT_DATES).forEach(([symbol, contracts]) => {
            // Find the active contract based on current date
            let activeContract = null;

            for (let i = 0; i < contracts.length; i++) {
                const [year, month, day] = contracts[i][0].split('-').map(Number);
                const startDate = new Date(year, month - 1, day);
                
                // If we haven't passed this contract's start date yet, the previous contract is active
                if (startDate > today) {
                    activeContract = i > 0 ? contracts[i - 1] : contracts[0];
                    break;
                }
                
                // If this is the last contract, it becomes active
                if (i === contracts.length - 1) {
                    activeContract = contracts[i];
                }
            }

            if (activeContract) {
                active[symbol] = activeContract;
            }
        });

        setActiveContracts(active);
    }, []);

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className="contracts-container">
            <h2 className="sub-headline">Futures Contracts</h2>
            <div className="filter-container">
                <input
                    type="text"
                    placeholder="🔍 Filter by Symbol"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    className="filter-input"
                />
            </div>

            <div className="contracts-grid">
                {Object.entries(SYMBOL_CONTRACT_DATES)
                    .filter(([symbol]) => 
                        symbol.toLowerCase().includes(filterText.toLowerCase())
                    )
                    .map(([symbol, contracts]) => (
                        <div key={symbol} className="contract-card">
                            <h3>{symbol}</h3>
                            <div className="contract-dates">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Start Date</th>
                                            <th>Contract</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contracts.map(([expiryDate, contractName], index) => {
                                            const isActive = activeContracts[symbol]?.[0] === expiryDate;
                                            return (
                                                <tr 
                                                    key={index}
                                                    className={isActive ? 'active-contract' : ''}
                                                >
                                                    <td>{formatDate(expiryDate)}</td>
                                                    <td>{contractName}</td>
                                                    <td>
                                                        {isActive ? (
                                                            <span className="active-badge">Active</span>
                                                        ) : (
                                                            <span className="inactive-badge">Inactive</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default ContractsView;
